module.exports = __webpack_public_path__ + "img/march-1.b7887336.jpg";